import _implicitStylesheets from "./onlyTextEmptySpace.css";
import _implicitScopedStylesheets from "./onlyTextEmptySpace.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div${"c0"}${2}><div class="slds-grid empty-space-description${0}"${2}>${"t2"}</div></div>`;
const $fragment2 = parseFragment`<div class="slds-grid slds-grid_align-spread${0}"${2}><div class="required-message${0}"${2}><span${3}>${"t3"}</span></div></div>`;
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  return [api_static_fragment($fragment1, 1, [api_static_part(0, {
    className: api_normalize_class_name($cmp.onlyTextEmptySpaceCSS)
  }, null), api_static_part(2, null, api_dynamic_text($cmp.label))]), $cmp.required ? api_static_fragment($fragment2, 3, [api_static_part(3, null, api_dynamic_text($cmp.requiredText))]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1790n87h0ib";
tmpl.legacyStylesheetToken = "appx-emptySpace_onlyTextEmptySpace";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
